import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DepartmentMapCourse from "./routes/DepartmentMapCourse";

export default store => ({
  path: ":gradeId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "department-map-grade-details" */ "./components"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [DepartmentMapCourse(store)],
});
